import React, { useEffect, useState } from "react";
import { Typography, Flex, Row, Col, Card, Button, Spin, Tag } from "antd";
import { EnvironmentOutlined, ClockCircleOutlined } from "@ant-design/icons";
import TopNavigation from "./snipets/TopNavigation";
import Footer from "./snipets/Footer";
import {VacancyService} from "../services/VacancyService";
import JobApplicationModal from "../modals/JobApplicationModal";
import {Vacancy} from "../models/Vacancy";

const { Title, Text, Paragraph } = Typography;

const BRAND       = "#00AF66";

const VacanciesPage: React.FC = () => {
    const [vacancies, setVacancies] = useState<Vacancy[]>([]);
    const [loading, setLoading]     = useState(true);

    const [selectedVacancy, setSelectedVacancy] = useState<Vacancy | null>(null);
    const [modalOpen, setModalOpen]             = useState(false);

    const loadVacancies = () => {
        setLoading(true);
        VacancyService.getVacancies()
            .then((data) => setVacancies(data))
            .catch(() => setVacancies([]))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadVacancies();
    }, []);

    const handleApply = (vacancy: Vacancy) => {
        setSelectedVacancy(vacancy);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedVacancy(null);
    };

    return (
        <>
            <TopNavigation />

            <div style={{ background: "#f5f5f0", padding: "96px 16px 64px" }}>
                <Flex vertical align="center" style={{ marginBottom: 40, textAlign: "center" }}>
                    <Title style={{ fontSize: "clamp(26px, 4vw, 38px)", marginBottom: 8 }}>
                        Careers
                    </Title>
                    <Paragraph type="secondary" style={{ fontSize: "clamp(15px, 2vw, 18px)", maxWidth: 520 }}>
                        Join our team. Browse our open vacancies below and apply directly.
                    </Paragraph>
                </Flex>

                {loading ? (
                    <Flex justify="center" style={{ padding: "48px 0" }}>
                        <Spin size="large" />
                    </Flex>
                ) : vacancies.length === 0 ? (
                    <Flex vertical align="center" style={{ paddingTop: 40 }} gap={8}>
                        <Text type="secondary">There are no open vacancies right now. Please check back soon.</Text>
                    </Flex>
                ) : (
                    <Row gutter={[20, 20]} justify="center">
                        {vacancies.map((vacancy) => (
                            <Col xs={24} sm={12} lg={8} key={vacancy.id}>
                                <Card style={{ height: "100%" }}>
                                    <Flex vertical gap={12} style={{ height: "100%" }}>
                                        <div>
                                            <Title level={4} style={{ margin: 0 }}>{vacancy.title}</Title>
                                            {/* `department` isn't a field on Vacancy yet -- add it to the
                                                model/schema/class if this is actually needed, or remove
                                                this block if it isn't. */}
                                        </div>

                                        <Flex gap={8} wrap="wrap">
                                            {(vacancy.city || vacancy.province) && (
                                                <Tag icon={<EnvironmentOutlined />} color={BRAND}>
                                                    {[vacancy.city, vacancy.province].filter(Boolean).join(", ")}
                                                </Tag>
                                            )}
                                            {vacancy.job_type && (
                                                <Tag icon={<ClockCircleOutlined />}>
                                                    {vacancy.job_type}
                                                </Tag>
                                            )}
                                        </Flex>

                                        {vacancy.description && (
                                            <Paragraph
                                                type="secondary"
                                                ellipsis={{ rows: 3 }}
                                                style={{ marginBottom: 0, flex: 1 }}
                                            >
                                                {vacancy.description}
                                            </Paragraph>
                                        )}

                                        <Button type="primary" block onClick={() => handleApply(vacancy)}>
                                            Apply now
                                        </Button>
                                    </Flex>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </div>

            <JobApplicationModal
                open={modalOpen}
                vacancy={selectedVacancy}
                onClose={handleCloseModal}
            />

            <Footer />
        </>
    );
};

export default VacanciesPage;